import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai';
import { Modal, Button, Form } from 'react-bootstrap';
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import { GoDownload } from "react-icons/go";
import socket from "../../../socket";


const LeaveRequest = () => {
    const { setLoading } = useLoading();
    const [leaveData, setLeaveData] = useState([]);
    const [selectedLeave, setSelectedLeave] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [hrNote, setHrNote] = useState('');
    const [searchTerm, setSearchTerm] = useState('');


    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success',
    });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };



    useEffect(() => {

        socket.on("leave-apply", (data) => {
            showToast(data.message, "info");
        });

        return () => socket.off("leave-apply");
    }, []);


    // Fetch leave data
    const fetchLeave = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-leave');
            const sorted = Array.isArray(res.data.result)
                ? [...res.data.result].sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0))
                : res.data.result;
            setLeaveData(sorted);
            console.log(res.data.result);
            // return res.data.result;
        } catch (error) {
            console.error('Error fetching leave data', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeave();
    }, []);

    // Open modal with selected leave details
    const handleActionClick = (leave) => {
        setSelectedLeave(leave);
        setHrNote(leave.hr_note || '');
        setShowModal(true);
    };

    // Handle Approve/Reject
    const handleStatusUpdate = async (status) => {
        try {
            await axios.put(`https://api.skyguard.group/api/update-leave-status/${selectedLeave.id}`, {
                approval_status: status,
                hr_note: hrNote
            });


            fetchLeave();
            setShowModal(false);

            // alert(`Leave ${status} successfully!`);
            setToast({
                show: true,
                message: `Leave ${status} successfully!`,
                bg: 'success',
            });
        } catch (error) {
            console.error('Error updating leave status:', error);
            // alert('Failed to update leave status');
            setToast({
                show: true,
                message: 'Failed to update leave status',
                bg: 'danger',
            });
        }
    };



    const filteredData = (leaveData || []).filter(itm =>
        Object.values(itm || {}).some(val =>
            String(val || "").toLowerCase().includes(searchTerm.toLowerCase())
        )
    );


    const handleExportWord = async () => {
        if (!selectedLeave) return;

        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({ text: "Employee: ", bold: true }),
                                new TextRun(`${selectedLeave.emp_name} (${selectedLeave.emp_id})`),
                            ],
                        }),
                        new Paragraph({
                            children: [
                                new TextRun({ text: "Leave Type: ", bold: true }),
                                new TextRun(selectedLeave.leave_type),
                            ],
                        }),
                        new Paragraph({
                            children: [
                                new TextRun({ text: "From: ", bold: true }),
                                new TextRun(selectedLeave.from_date),
                            ],
                        }),
                        new Paragraph({
                            children: [
                                new TextRun({ text: "To: ", bold: true }),
                                new TextRun(selectedLeave.to_date),
                            ],
                        }),
                        new Paragraph({
                            children: [
                                new TextRun({ text: "Total Days: ", bold: true }),
                                new TextRun(selectedLeave.total_days),
                            ],
                        }),
                        new Paragraph({
                            children: [
                                new TextRun({ text: "Total Amount: ", bold: true }),
                                new TextRun(`₹ ${selectedLeave.total_amount || "0.00"}`),
                            ],
                        }),
                        new Paragraph({ text: "" }), // empty line for spacing
                        new Paragraph({
                            children: [new TextRun({ text: "Reason:", bold: true })],
                        }),
                        new Paragraph(selectedLeave.reason || ""),
                        new Paragraph({ text: "" }),
                        new Paragraph({
                            children: [new TextRun({ text: "Address During Leave:", bold: true })],
                        }),
                        new Paragraph(selectedLeave.address || ""),
                        new Paragraph({ text: "" }),
                        new Paragraph({
                            children: [new TextRun({ text: "HR Note:", bold: true })],
                        }),
                        new Paragraph(hrNote || ""),
                    ],
                },
            ],
        });

        const blob = await Packer.toBlob(doc);
        saveAs(blob, `Leave_Report_${selectedLeave.emp_id}.docx`);
    };

    return (
        <>
            <div className="main-section">
                <div className="container-fluid dashboard-wrapper p-3 bg-body-secondary">
                    <h3 className="my-3 fw-bold fs-5 golos">Leave Requests</h3>

                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-6">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />

                        </div>
                    </div>


                    {/* Table */}
                    <div className="table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4">
                        <table className="table table-bordered table-striped text-center table-sm align-middle">
                            <thead className="table-info">
                                <tr>
                                    <th>S No</th>
                                    <th>Action</th>
                                    <th>Apply On</th>
                                    <th>Applied By</th>
                                    <th>Type</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Status</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <Button
                                                    variant="outline-info"
                                                    size="sm"
                                                    onClick={() => handleActionClick(item)}
                                                >
                                                    Review
                                                </Button>
                                            </td>
                                            <td>{item.leave_date}</td>
                                            <td>{item.emp_name}</td>
                                            <td>{item.leave_type}</td>
                                            <td>{item.from_date}</td>
                                            <td>{item.to_date}</td>
                                            <td>
                                                <span
                                                    className={`badge ${item.approval_status === 'Approved'
                                                        ? 'bg-success'
                                                        : item.approval_status === 'Rejected'
                                                            ? 'bg-danger'
                                                            : 'bg-warning text-dark'
                                                        }`}
                                                >
                                                    {item.approval_status}
                                                </span>
                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-muted">
                                            No leave requests found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg" backdrop="static">
                <Modal.Header closeButton className="bg-info bg-opacity-25">
                    <Modal.Title className="fw-bold text-primary">
                        📝 Review Leave Request
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {selectedLeave && (
                        <div className="p-2">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Employee:</strong>
                                    <div className="text-muted">{selectedLeave.emp_name} ({selectedLeave.emp_id})</div>
                                </div>
                                <div className="col-md-6">
                                    <strong>Leave Type:</strong>
                                    <div className="text-muted">{selectedLeave.leave_type}</div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>From:</strong>
                                    <div className="text-muted">{selectedLeave.from_date}</div>
                                </div>
                                <div className="col-md-6">
                                    <strong>To:</strong>
                                    <div className="text-muted">{selectedLeave.to_date}</div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Total Days:</strong>
                                    <div className="text-muted">{selectedLeave.total_days}</div>
                                </div>
                                <div className="col-md-6">
                                    <strong>Total Amount:</strong>
                                    <div className="text-muted">₹ {selectedLeave.total_amount || '0.00'}</div>
                                </div>
                            </div>

                            <div className="mb-3">
                                <strong>Reason:</strong>
                                <div className="border rounded p-2 bg-light">{selectedLeave.reason}</div>
                            </div>

                            <div className="mb-3">
                                <strong>Address During Leave:</strong>
                                <div className="border rounded p-2 bg-light">{selectedLeave.address}</div>
                            </div>

                            <Form.Group className="mt-4">
                                <Form.Label className="fw-semibold text-secondary">
                                    HR Note <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    value={hrNote}
                                    onChange={(e) => setHrNote(e.target.value)}
                                    placeholder="Enter note for approval or rejection..."
                                    className="border-info shadow-sm"
                                />
                            </Form.Group>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between bg-light">
                    <div>
                        <strong>Status:</strong>{" "}
                        <span
                            className={`badge ${selectedLeave?.approval_status === 'Approved'
                                ? 'bg-success'
                                : selectedLeave?.approval_status === 'Rejected'
                                    ? 'bg-danger'
                                    : 'bg-warning text-dark'
                                }`}
                        >
                            {selectedLeave?.approval_status || 'Pending'}
                        </span>
                    </div>

                    <div>
                        <Button
                            variant="outline-danger"
                            onClick={() => handleStatusUpdate('Rejected')}
                            className="me-2"
                        >
                            <AiOutlineCloseCircle className="me-1" /> Reject
                        </Button>
                        <Button
                            variant="success"
                            onClick={() => handleStatusUpdate('Approved')}
                            className="me-2"
                        >
                            <AiOutlineCheckCircle className="me-1" /> Approve
                        </Button>

                        <Button
                            variant="outline-dark"
                            onClick={() => handleExportWord('')}

                        >
                            <GoDownload className="mx-1" /> Download
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />


        </>
    );
};

export default LeaveRequest;